import React, { Fragment } from "react";
import GnpModalGeneric from "../controllers/gnp-modal/index.jsx";

export const UtilModal = ({ modal_text, modal_properties }, events) => {
  return (
    <Fragment>{switchModal(modal_text, modal_properties, events)}</Fragment>
  );
};

const switchModal = (modal_text, modal_properties, events) => {
  const {
    title_modal,
    paragrahp1,
    textButtonConfirm
  } = modal_text;
  const {
    type_modal,
    open_modal,
    image,
    mobileQuery,
    nameQuery,
  } = modal_properties;
  let elementsToBody = {};
  let body = {};
  let propertiesModal = {};

  switch (type_modal) {
    case "defaultModal":
      propertiesModal = {
        open: open_modal,
        onClose: events.onClose,
        typeModal: type_modal,
        title: title_modal,
        mobileQuery,
        nameQuery,
        textButtonConfirm,
        onClickAcepted:events.onClose
      };
      body = (
        <Fragment>
          {paragrahp1 && <p className="paraghap-color center-content">{paragrahp1}</p>}
          <img className="img-modal" src={image}></img>
        </Fragment>
      );
      break;
  }
  elementsToBody = (
    <GnpModalGeneric {...propertiesModal}>{body}</GnpModalGeneric>
  );
  return elementsToBody;
};



// WEBPACK FOOTER //
// ./src/mascotas/util-modal.js